import React from 'react';
import ASCIILoader from 'js/components/elements/ASCIILoader';
import { ERROR_MESSAGES } from '../../constants';
import s from '../../FlowRunLogs.module.scss';

type LogListFooterProps = {
  loading?: boolean;
  showReachedEndMessage?: boolean;
};

export const LogListFooter: React.FC<LogListFooterProps> = ({
  loading = false,
  showReachedEndMessage = false,
}) => {
  if (loading) {
    return (
      <div className={s.asciiLoader}>
        <ASCIILoader />
      </div>
    );
  }

  const msg = showReachedEndMessage ? ERROR_MESSAGES.REACHED_END : '';

  return (
    <div className={s.noMoreLogsText}>
      <span className={s.greyscale400Text}>{msg}</span>
    </div>
  );
};
